import { b } from './chunk-IMSWER4T.js';

var i=class extends b{URL="clients";async getModulesForClient({page:n=1,limit:l=15,query:e="",sortBy:t=""},s,o){return (await this._client.get(`/clients/${s}/modules?${o!=null?"type="+o+"&":""}page=${n}&limit=${l}${e!==""?"&query="+e:""}${t!==""?"&sortBy="+t:""}`)).data}};

export { i as a };
//# sourceMappingURL=chunk-IU6GDJFD.js.map
//# sourceMappingURL=chunk-IU6GDJFD.js.map